import { client } from "@lib/api"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import * as Sentry from "@sentry/react"

export type ExchangeRateResponse = {
    uuid: string,
    ex_rate: string,
    inverse_rate: string,
    size: string,
    total: string,
    fees: {
        network_fee: number,
        income_tax: number,
        vat: number,
        total_fees: number
    },
    valid_time: number
}

type Mode = 'variable-jidr' | 'fixed-jidr' | undefined | null

const useExchangeRate = () => {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    async function getExchangeRate(assetId: string): Promise<ExchangeRateResponse>;
    async function getExchangeRate(assetId: string, amount: string, mode: 'variable-jidr' | 'fixed-jidr'): Promise<ExchangeRateResponse>;
    async function getExchangeRate(assetId: string, amount?: string, mode?: Mode): Promise<ExchangeRateResponse> {
        try {
            setError(null)
            setIsLoading(true)
            let url
            switch (mode) {
                case 'variable-jidr':
                    url = `/wallet/exchange-rate?from_asset=${assetId}&to_asset=JIDR&from_amount=${amount}`
                    break
                case 'fixed-jidr':
                    url = `/wallet/exchange-rate?from_asset=${assetId}&to_asset=JIDR&to_amount=${amount}`
                    break
                default:
                    url = `/wallet/exchange-rate?from_asset=${assetId}&to_asset=JIDR&from_amount=1`
            }
            const response = await client.doGet(url)
            return response as ExchangeRateResponse
        } catch (error) {
            Sentry.captureException(error)
            setError(t('errors.1006.description'))
            throw error
        } finally {
            setIsLoading(false)
        }
    }

    return {
        getExchangeRate,
        isLoading,
        error
    }
}

export default useExchangeRate